import { pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  typedJsonb,
  JsonRootData,
} from '../common/utils'

export const formSubmissions = pgTable(
  'form_submissions',
  {
    ...getBaseFields(),
    formId: text(),
    source: text(),
    data: typedJsonb<JsonRootData>('data').notNull(),
    // Two touches stored separately so the shape matches every other table
    // (single AcquisitionData, not AttributionPayload). firstTouch is the
    // actor-history claim the client cookie is uniquely authoritative about
    // pre-identity; lastTouch is the event-time channel for this submission.
    // Legacy flat utm_* clients are normalized into both columns server-side
    // (synthesized first == last) by normalizeAttributionInput.
    internalFirstTouchAcquisition: typedJsonb(
      'internal_first_touch_acquisition',
    ),
    internalLastTouchAcquisition: typedJsonb('internal_last_touch_acquisition'),
    ipAddress: text(),
    userAgent: text(),
  },
  (table) => getBaseIndexes('form_submissions', table),
)
